var map = {
	".": 18305,
	"./": 18305,
	"./App": 72845,
	"./App.css": 93508,
	"./App.js": 72845,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./Card": 55372,
	"./Card.js": 55372,
	"./Slider": 92188,
	"./Slider.js": 92188,
	"./images/Cerchio software Koala_hero.png": 59462,
	"./images/KOALA1.png": 32576,
	"./images/Koala Copertina YT.png": 41281,
	"./images/Koala VR.png": 455,
	"./images/Software Koala_hero.png": 26547,
	"./images/Software Koala_hero_min.png": 64993,
	"./images/bg2560.png": 25217,
	"./images/icon-koala.png": 521,
	"./images/icon-white-koala.png": 13649,
	"./images/icons/6.png": 34624,
	"./images/icons/7.png": 30227,
	"./images/icons/8.png": 54257,
	"./images/icons/9.png": 19197,
	"./images/icons/archivio.png": 17640,
	"./images/icons/attestati.png": 9471,
	"./images/icons/aule.png": 48406,
	"./images/icons/blockchain.png": 92510,
	"./images/icons/dvr.png": 10521,
	"./images/icons/generazione.png": 84169,
	"./images/icons/intelligenza.png": 67943,
	"./images/icons/monitoraggio.png": 82269,
	"./images/icons/pianificazione.png": 8542,
	"./images/icons/produttivita.png": 82643,
	"./images/icons/software.png": 90397,
	"./images/icons/soprallughi.png": 17824,
	"./images/icons/suite.png": 60989,
	"./images/logo-full.png": 90289,
	"./images/logo-white-full.png": 77941,
	"./images/logo-white-koala.png": 84465,
	"./images/new-logo-light-min.png": 65596,
	"./images/new-logo-light.png": 3018,
	"./images/new-logo-min.png": 46082,
	"./images/new-miller-logo.png": 39571,
	"./images/new-mockup.png": 49754,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40407;